import { PriceResponseType } from 'data/Price/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const getAll = (
  base: string,
  quote: string,
  start: number,
  end: number,
  granularity: number
) =>
  fetchApi<PriceResponseType>({
    method: 'GET',
    url: getApiUrl(
      `nabu-gateway/markets/exchange/prices?symbol=${base}-${quote}&start=${start}&end=${end}&granularity=${granularity}`
    )
  })
